/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */

export type ResponsibilityRole = typeof ResponsibilityRole[keyof typeof ResponsibilityRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ResponsibilityRole = {
  ProductManager: 'ProductManager',
  YieldManager: 'YieldManager',
  TourLeader: 'TourLeader',
  TourGuide: 'TourGuide',
} as const;
